<template>
    <div style="display: flex;justify-content: space-between;width: 100%;height: 100%;">
        <div class="left"></div>
        <div style="fex:1;width: 100%;background: #fff;padding: 200px 0;">
            <div style="width: 40%;margin: 0 auto;">
                <div style="text-align: center;">
                    <img src="../assets/image/logo.png" style="height: 80px;" />
                </div>
                <!-- <div style="font-size: 30px;font-weight: bold;padding-top: 20px;">欢迎登录,</div> -->
                <div style="font-size: 24px;color: #999;margin-top:20px;text-align:center;margin-bottom:-20px">铁兽共享自助健身后台登录系统</div>
                <div style="padding: 40px 0;">
                    <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form">
                        <el-form-item prop="username">
                            <el-input v-model="loginForm.username"  prefix-icon="el-icon-user-solid" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码"  show-password type="password" @keypress.native.enter="login"></el-input>
                        </el-form-item>
                        <!-- <el-form-item class="btns">
                            <el-button type="primary" @click="login" >登录</el-button>
                            <el-button type="waring" @click="resetLoginForm">重置</el-button>
                        </el-form-item> -->
                        <el-form-item>
                        <div class="login" @click="login">
                            登录
                        </div>
                        <div class="reset" @click="resetLoginForm"> 
                            重置
                        </div>
                    </el-form-item>
                    </el-form>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            loginForm: {
                username: '',
                password: ''
            },
            loginFormRules: {
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 5, max: 20, message: '用户名长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        resetLoginForm() {
            this.$refs.loginFormRef.resetFields();
        },
        async login() {
            
                this.$refs.loginFormRef.validate( async valid => {
                    if(!valid) return;
                    try{
                        // 移除IP地址查询，使用固定值或设备标识
                        const deviceId = 'web_' + Date.now().toString(36);
                        
                        const loginData = {
                            ...this.loginForm,
                            machinecode: deviceId  // 使用设备标识替代IP地址
                        };
                        
                        const { data:res } = await this.$http.post('adminlogin/', loginData);
                        if (res.status !== 0) return this.$message.error(res.message);
                        this.$message.success('登录成功！');
                        // 存储用户基本信息
                        window.sessionStorage.setItem('admin_token', res.username);
                        window.sessionStorage.setItem('name_token', res.name);
                        window.sessionStorage.setItem('username', res.username); // 添加用户名，用于超级管理员检查
                        window.sessionStorage.setItem('pass_token', res.password);
                        // 存储认证token，用于API请求认证
                        if (res.token) {
                            window.sessionStorage.setItem('login_token', res.token);
                            console.log('成功存储JWT token:', res.token.substring(0, 20) + '...');
                        } else {
                            console.error('登录响应中没有token字段');
                            window.sessionStorage.setItem('login_token', res.username); // 降级处理
                        }
                        // 存储用户ID
                        if (res.userinfo && Array.isArray(res.userinfo) && res.userinfo.length > 0) {
                            const userId = res.userinfo[0].id;
                            if (userId) {
                                window.sessionStorage.setItem('userId', userId);
                                console.log('成功存储用户ID:', userId);
                            }
                            // 同时存储整个userinfo对象，以备后用
                            window.sessionStorage.setItem('userinfo', JSON.stringify(res.userinfo));
                        }
                        
                        console.log('登录成功，存储用户信息:', {
                            username: res.username,
                            name: res.name,
                            token: res.token || res.username,
                            roles: res.roles
                        });
                        
                        // 登录成功后，调用getperlist接口获取完整的权限数据
                        try {
                            const { data: permRes } = await this.$http.get('getperlist/');
                            console.log('获取权限数据成功:', permRes);
                            
                            if (permRes.status === 0) {
                                // 存储所有菜单数据，用于动态渲染菜单
                                window.sessionStorage.setItem('menuPermissions', JSON.stringify(permRes.data));
                                
                                // 提取所有菜单的permissionCode用于路由权限检查
                                const menuPermissions = [];
                                const extractPermissions = (menus) => {
                                    menus.forEach(menu => {
                                        if (menu.permissionCode) {
                                            menuPermissions.push(menu.permissionCode);
                                            console.log(`提取菜单权限: ${menu.lbname} -> ${menu.permissionCode}`);
                                        }
                                        if (menu.children && Array.isArray(menu.children)) {
                                            extractPermissions(menu.children);
                                        }
                                    });
                                };
                                
                                // 处理菜单数据，提取权限代码
                                if (permRes.data && Array.isArray(permRes.data)) {
                                    extractPermissions(permRes.data);
                                }
                                
                                console.log('当前用户权限:', menuPermissions);
                                
                                // 存储菜单权限代码列表，用于路由权限检查
                                window.sessionStorage.setItem('perid_token', JSON.stringify(menuPermissions));
                                
                                // 存储按钮权限数据
                                if (permRes.buttonPermissions && Array.isArray(permRes.buttonPermissions)) {
                                    window.sessionStorage.setItem('buttonPermissions', JSON.stringify(permRes.buttonPermissions));
                                }
                                
                                // 存储角色信息（如果有的话）
                                if (permRes.roles) {
                                    window.sessionStorage.setItem('roles', JSON.stringify(permRes.roles));
                                }
                            } else {
                                console.error('获取权限数据失败:', permRes.message);
                                // 如果获取权限失败，使用登录接口返回的基本权限信息
                                this.handleBasicPermissions(res);
                            }
                        } catch (permError) {
                            console.error('调用getperlist接口失败:', permError);
                            // 如果权限接口调用失败，使用登录接口返回的基本权限信息
                            this.handleBasicPermissions(res);
                        }
                        
                        // 检查用户权限并跳转到合适的页面
                        const menuPermissions = JSON.parse(window.sessionStorage.getItem('perid_token') || '[]');
                        const menuData = JSON.parse(window.sessionStorage.getItem('menuPermissions') || '[]');
                        
                        // 检查是否是超级管理员
                        const nameToken = window.sessionStorage.getItem('name_token');
                        const username = window.sessionStorage.getItem('username');
                        const isSuperAdmin = nameToken === 'admin' || username === 'admin' || nameToken === '超级管理员';
                        
                        console.log('当前用户名:', nameToken, username);
                        console.log('是否超级管理员:', isSuperAdmin);
                        console.log('当前用户权限:', menuPermissions);
                        console.log('菜单数据:', menuData);
                        
                        // 如果是超级管理员，直接跳转到首页
                        if (isSuperAdmin) {
                            console.log('超级管理员登录，直接跳转到首页');
                            this.$router.push('/welcome').catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('导航错误:', err);
                                }
                            });
                            return;
                        }
                        
                        // 检查菜单数据是否为空
                        if (!menuData || menuData.length === 0) {
                            console.log('菜单数据为空，跳转到无权限页面');
                            this.$router.push('/no-access').catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('导航错误:', err);
                                }
                            });
                            return;
                        }
                        
                        // 检查是否有客服门店管理权限，如果有则优先跳转到客服门店管理页面
                        const hasCustomerStorePermission = menuPermissions.includes('menu:customer-store:list');
                        console.log('是否有客服门店管理权限:', hasCustomerStorePermission);
                        
                        if (hasCustomerStorePermission) {
                            console.log('用户有客服门店管理权限，优先跳转到客服门店管理页面');
                            this.$router.push('/customer-stores').catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('导航错误:', err);
                                }
                            });
                            return;
                        }
                        
                        // 检查是否有首页权限
                        const hasHomePermission = menuPermissions.includes('menu:home:welcome');
                        console.log('是否有首页权限:', hasHomePermission);
                        
                        if (hasHomePermission) {
                            console.log('用户有首页权限，跳转到首页');
                            this.$router.push('/welcome').catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('导航错误:', err);
                                }
                            });
                            return;
                        }
                        
                        // 如果没有首页菜单，尝试找到第一个有路由的菜单
                        let foundMenu = null;
                        
                        // 递归函数找到第一个有路由的菜单
                        const findFirstRoutableMenu = (menus) => {
                            for (const menu of menus) {
                                if (menu.router && menu.type === 1) {
                                    return menu;
                                }
                                if (menu.children && menu.children.length > 0) {
                                    const childMenu = findFirstRoutableMenu(menu.children);
                                    if (childMenu) return childMenu;
                                }
                            }
                            return null;
                        };
                        
                        foundMenu = findFirstRoutableMenu(menuData);
                        
                        if (foundMenu) {
                            console.log('找到第一个可路由菜单:', foundMenu);
                            const routePath = '/' + foundMenu.router;
                            this.$router.push(routePath).catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('导航错误:', err);
                                }
                            });
                            return;
                        }
                        
                        // 如果以上方法都失败，尝试使用权限代码检查
                        if (menuPermissions.includes('menu:home:welcome')) {
                            // 有首页权限，跳转到首页
                            this.$router.push('/index').catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error('导航错误:', err);
                                }
                            });
                        } else {
                            // 没有首页权限，找到第一个有权限的页面
                            let foundRoute = false;
                            
                            // 打印调试信息
                            console.log('当前用户权限:', menuPermissions);
                            console.log('路由权限映射:', routePermissionsMap);
                            
                            // 先检查菜单数据中的路由
                            for (const menu of menuData) {
                                if (menu.router && menu.type === 1) { // 确保是菜单类型，不是按钮
                                    const routePath = '/' + menu.router;
                                    console.log('尝试跳转到菜单路由:', routePath);
                                    this.$router.push(routePath).catch(err => {
                                        if (err.name !== 'NavigationDuplicated') {
                                            console.error('导航错误:', err);
                                        }
                                    });
                                    foundRoute = true;
                                    break;
                                }
                            }
                            
                            // 如果菜单数据中没有可用路由，尝试使用权限映射表
                            if (!foundRoute) {
                                for (const [route, permission] of Object.entries(routePermissionsMap)) {
                                    if (permission && menuPermissions.includes(permission)) {
                                        console.log('找到用户有权限的页面:', route);
                                        this.$router.push(route).catch(err => {
                                            if (err.name !== 'NavigationDuplicated') {
                                                console.error('导航错误:', err);
                                            }
                                        });
                                        foundRoute = true;
                                        break;
                                    }
                                }
                            }
                            
                            // 如果没有找到任何有权限的页面，跳转到无权限页面
                            if (!foundRoute) {
                                this.$router.push('/no-access').catch(err => {
                                    if (err.name !== 'NavigationDuplicated') {
                                        console.error('导航错误:', err);
                                    }
                                });
                            }
                        }
                    } catch (error) {
                        console.error('登录失败:', error);
                    }
                })
            
        },
        handleBasicPermissions(res) {
            // 处理权限信息 - 支持新旧两种权限模式
            if (res.roles && res.buttonPermissions) {
                // 新的基于角色的权限系统
                window.sessionStorage.setItem('roles', JSON.stringify(res.roles));
                window.sessionStorage.setItem('buttonPermissions', JSON.stringify(res.buttonPermissions));
                // 为了兼容性，将角色列表也存储为perid格式
                window.sessionStorage.setItem('perid_token', JSON.stringify(res.roles));
            } else if (res.perid) {
                // 旧的权限系统
                window.sessionStorage.setItem('perid_token', res.perid);
                // 初始化空的按钮权限列表
                window.sessionStorage.setItem('buttonPermissions', JSON.stringify([]));
            }
        }
    }
}
</script>
<style scoped>
    .left{
        fex:1;width: 100%;background: url(../assets/image/bg.png);
       background-position:50% 50%;
       background-size:cover;
       background-repeat:no-repeat;
       
    }
   .login{
        background: #ff4500;border-radius: 20px;color:#fff;font-size: 25px;cursor:pointer;text-align: center;height: 60px;line-height: 60px;
    }
    .reset{
        border-radius: 20px;color:#ff4500;margin-top: 20px;font-size: 25px;cursor:pointer;text-align: center;height: 60px;line-height: 60px;border:1px solid #ff4500;
    }
    /deep/.el-input__inner{
        height: 60px;
        border-radius:10px;
        font-size: 20px;
    }
</style>